<template>
  <v-card elevation="0">
    <v-dialog v-model="dialog" max-width="500">
      <Confirm
          title="Salvar"
          message="Tem certeza de que deseja salvar estes dados?"
          buttonText="Salvar"
          @cancel="dialog = false"
          @action="submit"
      />
    </v-dialog>

    <v-form ref="personalInformation">
      <v-row class="pa-4 pb-0 ma-0">
        <v-col sm="12" md="6">
          <v-icon color="normalred" size="22">mdi-account-outline</v-icon>
          <span class="step-title">Informações Pessoais</span>
          <br/>
          <span class="step-subtitle ml-3">Informações pessoais para cadastro</span>
          <br/>
        </v-col>

        <v-col sm="12" md="6" class="d-flex justify-end">
          <span class="required-field">*Campos são obrigatórios</span>
        </v-col>

        <v-col cols="12" sm="12" md="6" lg="4">
          <span class="label">Razão Social<strong style="color: #bc0000">*</strong></span>
          <v-text-field
              dense
              clearable
              outlined
              maxlength="45"
              placeholder="Meu nome"
              v-model="currentUser.name"
              :rules="[rules.nameRules]"
              required
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="6" lg="4">
          <span class="label">Nome Fantasia<strong style="color: #bc0000">*</strong></span>
          <v-text-field
              dense
              clearable
              outlined
              placeholder="Meu nome fantasia"
              maxlength="45"
              :rules="[rules.nameRules]"
              v-model="currentUser.nameFantasy"
              required
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="6" lg="4">
          <span class="label">CNPJ/CPF<strong style="color: #bc0000">*</strong></span>
          <v-text-field
              dense
              outlined
              style="font-size: small !important"
              v-model="currentUser.cnpj"
              :disabled="true"
              rounded
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="6" lg="4">
          <span class="label"> Telefone </span>
          <v-text-field
              dense
              outlined
              placeholder="(00)00000-0000"
              v-mask="['(##) #####-####']"
              :rules="[rules.required]"
              v-model="currentUser.phoneNumber"
              required
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="6" lg="4">
          <span class="label"> Celular (Opcional) </span>
          <v-text-field
              dense
              outlined
              v-mask="['(##) #####-####']"
              placeholder="(00)00000-0000"
              v-model="currentUser.phoneNumber2"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="12" lg="12">
          <span class="label"> Observações </span>
          <v-textarea
              dense
              placeholder="Minhas observações"
              no-resize
              outlined
              v-model="currentUser.observations"
              rows="3"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row class="pb-3" justify="center">
        <v-col cols="12" md="6">
          <v-btn
              class="primary-button"
              color="normalred"
              elevation="0"
              @click="validate()"
              block
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import Confirm from "../../components/ConfirmExit.vue";

export default {
  name: "PersonalInformation",
  components: {
    Confirm,
  },
  props: {},
  data: () => ({
    urlB2C: process.env.VUE_APP_BASE_URL_FRONT,
    currentUser: {
      image: "",
      Name: "",
      defaultFrete: "",
      agreement: false,
      cnpj: "",
      inscrEstadual: "",
      phoneNumber: "",
      phoneNumber2: "",
      birthDate: "",
      postalCode: "",
      state: "",
      city: "",
      neighborhood: "",
      addressName: "",
      addressNumber: "",
      country: "",
      addressComplement: "",
      resaleRegion: "",
      category: "",
      region: "",
      password: "",
      password2: "",
      email: "",
      email2: "",
      resaleWebSite: "",
      receiveEmail: "",
      receiveSms: "",
      textObservation: "",
      tokenMelhorEnvio: "",
      latitude: null,
      longitude: null,
      urlStoreResale: '',
    },
    apiService: new ApiService(),
    user: {},
    dialog: false,
    userTypeMaster: 0,
    userTypeAdmin: 1,
    userTypeResale: 2,
    userTypeInstaller: 3,
    specialties: [],
    rules: {
      nameRules: (v) => (v && v.length <= 128) || "Nome deve ter no máximo 128 caracteres",
      required: (value) => !!value || "Campo requerido.",
      min: (v) => v.length >= 4 || "Minimo de 4 caracteres.",
    },
  }),
  async created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.urlB2C = process.env.VUE_APP_BASE_URL_FRONT;
    await this.updateUser();
  },
  methods: {
    async copyUrl() {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard
            .writeText(this.currentUser.urlStoreResale)
            .then(() => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Url copiada.",
                trace: null,
              });
            })
            .catch((err) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "",
                message: "Não foi possível copiar url",
                trace: null,
              });
            });
      }
    },
    async updateUser() {
      this.loading = true;

      let url;

      switch (this.user.type) {
        case 0:
          url = "user/get-one";
          break;
        case 1:
        case 5:
          url = "user/get-one";
          break;
        case 2:
          url = "resale/get-one";
          break;
        case 3:
          url = "installer/get-one";
          break;
      }

      await this.apiService.get(`${url}?id=${this.user.id}`).then((response) => {
        this.currentUser = response;
        this.specialties = this.currentUser.specialties
        if(this.currentUser.urlStoreResale){
          this.currentUser.urlStoreResale = `${this.urlB2C}vitrine/${this.currentUser.urlStoreResale}`
        }
        this.loading = false;
      });
    },
    validate() {
      if (this.$refs.personalInformation.validate()) {
        this.dialog = true;
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "Formulário não validado",
          message: "Confira o preenchimento",
          trace: null,
        });
      }
    },
    async submit() {
      try {
        let model = this.currentUser;
        let url = '';
        switch (model.type) {
          case this.userTypeMaster:
          case this.userTypeAdmin:
            url = "user/edit";
            break;
          case this.userTypeResale:
            url = "resale/edit-user-resale";
            break;
          case this.userTypeInstaller:
            url = "installer/edit";
            this.currentUser.specialties = [];
            this.specialties.forEach((x) => {
              this.currentUser.specialties.push({
                specialtiesId: x.specialtiesId,
                installerId: this.currentUser.id,
              });
            });
            break;
        }
        await this.apiService.post(url, model)
          .then((resp) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: resp.message,
              message: resp.message,
              trace: null,
            });

            this.dialog = false;
            this.loading = false;
          })
          .catch((err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Erro ao cadastrar produto",
              message: err.body.message,
              trace: null,
            });

            this.dialog = false;
            this.loading = false;
          });
        await this.updateUser();
      } catch (e) {

      }
    },
  },
};
</script>
<style scoped>
</style>
